module.exports = __webpack_public_path__ + "img/complaints_card3.39d8cd5d.png";